import React, { ReactNode } from 'react';
import { Icon } from '@iwoca/orion';

import clsx from 'clsx';
import styles from './CriteriaItem.module.css';

type TProps = {
  children: ReactNode;
  hasPassed?: boolean;
  disabled?: boolean;
  testId?: string;
  className?: string;
};

export const CriteriaItem = ({
  children,
  hasPassed,
  disabled,
  testId,
  className,
}: TProps) => {
  return (
    <div
      className={clsx(styles.container, disabled && styles.disabled, className)}
    >
      {hasPassed || disabled ? (
        <Icon
          className={clsx(styles.icon, styles.passIcon)}
          icon="checkDefault"
          data-testid={`${disabled ? 'disabled' : 'enabled'}-pass-${testId}`}
        />
      ) : (
        <Icon
          className={clsx(styles.icon, styles.failIcon)}
          icon="plus"
          data-testid={`${disabled ? 'disabled' : 'enabled'}-fail-${testId}`}
        />
      )}
      {children}
    </div>
  );
};
